var React = require('react');

function Tl (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fillOpacity":".7","d":"M0 0h682.7v512H0z"}))),React.createElement("g",{"fillRule":"evenodd","clipPath":"url(#a)","transform":"scale(.9375)","key":1},[React.createElement("path",{"fill":"#cb000f","d":"M0 0h1031.2v512H0z","key":0}),React.createElement("path",{"fill":"#f8c00c","d":"M0 0c3.2 0 512 256.7 512 256.7L0 512V0z","key":1}),React.createElement("path",{"d":"M0 0c2.1 0 340.6 256.7 340.6 256.7L0 512V0z","key":2}),React.createElement("path",{"fill":"#fff","d":"M187.7 298.2L127 284.7l-31 52.8-5-59.7-60.7-13.3 54.9-24.9-3.3-59.3 40.2 43.4 55.4-25.3-28.9 54 39.2 45.8z","key":3})])]);
}

Tl.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Tl;

Tl.default = Tl;
